import moment from 'moment'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter, Prompt } from 'react-router'
import { Link, Switch, Route } from 'react-router-dom'
import { CSSTransition } from 'react-transition-group'
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { showMessage, closeMessage} from '../../../actions/messageBox'


class JoblogJsonTableViewer extends React.Component {
  constructor(props) {
    super(props);
    
  }

  render() {
    let { value, user } = this.props;



    let values = value;
    let userLists = user;
    let AuditVal;
    let AuditArr = [];
    let AuditArr2 = [];
    let emptyArr = [];
    let counter = 0;
    let ignoredPath = ["created_at", "updated_at"];

    for (let o in values){
      values[o].push
    }


    for (let n in values) {
      AuditArr.push(values[n]);
    }

    for (let b in AuditArr) {


      if (AuditArr[b] && AuditArr[b].updated_at) {
        let actualValue = AuditArr[b].updated_at.toString()
        // console.log("actualValue", actualValue)
        let displayText = actualValue && moment(actualValue).format('MM-DD-YYYY HH:mm:ss')
        // console.log("displayText", displayText)
        AuditArr[b].updated_at = displayText
      }

    //   if(AuditArr[b] && AuditArr[b].message_arguments){
    //     let parsedValue = JSON.parse(AuditArr[b].message_arguments)
    //     // console.log("parsedValue",parsedValue)
    //     JSON.parse(AuditArr[b].message_arguments)
        
    // AuditArr[b].parsedJSON = parsedValue
    //   }


      AuditArr[b].button = <div title="view details" onClick={e=>this.props.dispatch(
        showMessage({
            type: "info",
            title: "Details",
            autoClose: false,
            data:AuditArr[b],
            isJson:true
           
        })
    )} ><i className="fas fa-eye" style={{cursor:"pointer"}}></i></div>
    
    // console.log("AuditArr",AuditArr[b])


    }

   
    let finalArr = AuditArr.length ? AuditArr : emptyArr;

    // // console.log("finalArr", finalArr);

    const divStyle = {
      height: "calc(100vh - 226px) !important",
      overflow: "auto !important",
      margin: "5px"
    };

    const colStyle = {
      textAlign: "left",
      fontFamily: "var(--theme-font-family)",
      // backgroundColor: "#125EAC",
      color: "#000000",
      fontSize:"0.875rem"
    };

    const viewColStyle = {
      textAlign: "center",
      fontFamily: "var(--theme-font-family)",
      // backgroundColor: "#125EAC",
      color: "#000000",
      fontSize:"0.875rem"
    };

    const rowStyle = {
      wordWrap: "break-word",
      fontSize: "0.75rem",
    };

    const viewRowStyle = {
      wordWrap: "break-word",
      fontSize: "0.8125rem",
      // paddingLeft:"20px",
      textAlign:"center"
    }

    const noteStyle = {
      fontSize:"0.875rem",
      fontStyle:"Italic",
      color:"rgb(206, 206, 206)",
      paddingBottom:"1.00rem",
      paddingTop:"0.25rem"
    }

    const columns = [
      {
        dataField: "id",
        text: "ID",
        headerStyle: { width: "20px", ...colStyle },
        style: { ...rowStyle },
        sort: true
      },
      {
        dataField: "updated_at",
        text: "Executed At",
        headerStyle: { width: "20px",...colStyle },
        style: { ...rowStyle }
      },
      {
        dataField: "process_type",
        text: "Proccess Type",
        headerStyle: { width: "20px", ...colStyle },
        style: { ...rowStyle }
      },
      {
        dataField: "message_log",
        text: "Message Log",
        headerStyle: { width: "65px", ...colStyle },
        style: { ...rowStyle }
      },
      // {
      //   dataField: "message_arguments",
      //   text: "Arguments",
      //   headerStyle: { ...colStyle },
      //   style: { ...rowStyle }
      // },
      {
        dataField: "button" ,
        text:"Details",
        headerStyle: { width: "5px",...viewColStyle },
        style: { ...viewRowStyle }
      }
    ];

    const customTotal = (from, to, size) => (
      <span className="react-bootstrap-table-pagination-total">
        Showing {from} to {to} of {size} Results
      </span>
    );

    const options = {
      sizePerPage: 10,
      paginationSize: 4,
      pageStartIndex: 1,
      alwaysShowAllBtns: true, // Always show next and previous button
      withFirstAndLast: true, // Hide the going to First and Last page button
      hideSizePerPage: true, // Hide the sizePerPage dropdown always
      hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
      // firstPageText: 'First',
      prePageText: "Back",
      nextPageText: "Next",
      // lastPageText: 'Last',
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      // firstPageTitle: 'Next page',
      // lastPageTitle: 'Last page',
      showTotal: true,
      paginationTotalRenderer: customTotal,
      sizePerPageList: [
        {
          text: "5",
          value: 5
        },
        {
          text: "10",
          value: 10
        },
        {
          text: "All",
          value: AuditArr ? AuditArr.length : 0
        }
      ] // A numeric array is also available. the purpose of above example is custom the text
    };

    return (
      <div className="audit-table" style={divStyle}>
        {finalArr && (
          <BootstrapTable
            keyField="id"
            data={finalArr}
            columns={columns}
            pagination={paginationFactory(options)}
            striped={true}
            bordered={false}
            noDataIndication={() => <div>No audit available</div>}
          />
        )}
        </div>
    );
    
  }
}

// export default JoblogJsonTableViewer;
const mapStateToProps = state => {
	return {
		auth: state.auth
	}
}


export default connect(mapStateToProps)(JoblogJsonTableViewer)



// WEBPACK FOOTER //
// ./src/components/utilities/tabs/JoblogJsonTable.js